<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col cols="12" class="mb-4">
                <h2 slot="header" class="mb-0">รายละเอียดสินค้า</h2>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12"><h3>ข้อมูลสินค้า</h3></b-col>
              <b-col lg="2" md="12" class="text-lg-right mb-3">
                <p class="m-0">ชื่อสินค้า</p>
              </b-col>
              <b-col lg="4" md="12" class="mb-3">
                <b-form-input
                  size="sm"
                  v-model="itemDetails.name"
                ></b-form-input>
              </b-col>
              <b-col lg="2" md="12" class="text-lg-right mb-3">
                <p class="m-0">ประเภท</p>
              </b-col>
              <b-col lg="4" md="12" class="mb-3">
                <b-form-input
                  size="sm"
                  v-model="itemDetails.type"
                ></b-form-input>
              </b-col>
              <b-col lg="2" md="12" class="text-lg-right mb-3">
                <p class="m-0">ขนาด</p>
              </b-col>
              <b-col lg="4" md="12" class="mb-3">
                <b-form-input
                  size="sm"
                  v-model="itemDetails.dimension"
                ></b-form-input>
              </b-col>
              <b-col lg="2" md="12" class="text-lg-right mb-3">
                <p class="m-0">น้ำหนัก</p>
              </b-col>
              <b-col lg="4" md="12" class="mb-3">
                <b-form-input
                  size="sm"
                  v-model="itemDetails.weight"
                ></b-form-input>
              </b-col>
              <b-col lg="2" md="12" class="text-lg-right mb-3">
                <p class="m-0">ราคา</p>
              </b-col>
              <b-col lg="4" md="12" class="mb-3">
                <b-form-input
                  size="sm"
                  v-model="itemDetails.price"
                ></b-form-input>
              </b-col>
              <b-col lg="2" md="12" class="text-lg-right mb-3">
                <p class="m-0">รายละเอียดเพิ่มเติม</p>
              </b-col>
              <b-col lg="4" md="12" class="mb-3">
                <b-form-input
                  size="sm"
                  v-model="itemDetails.price"
                ></b-form-input>
              </b-col>
              <b-col lg="2" md="12" class="text-lg-right mb-3">
                <p class="m-0">รูปสินค้า</p>
              </b-col>
              <b-col lg="10" md="12" class="mb-3">
                <b-img
                  :src="itemDetails.image"
                  fluid
                  width="100px"
                  rounded
                ></b-img>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-end">
              <base-button
                type="secondary"
                class=""
                @click="
                  $router.push({
                    name: 'manageItem',
                  })
                "
              >
                ยกเลิก
              </base-button>
              <base-button type="primary" class="" @click="onsubmit">
                บันทึก
              </base-button>
            </div>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import items from "/src/db/item-list.json";

export default {
  components: {},
  props: {},
  data() {
    return {
      items,
      itemDetails: {},
    };
  },
  created() {},
  methods: {
    getItem() {
      const res = items.find((item) => {
        return this.$route.params.id == item.id;
      });
      this.itemDetails = res;
    },
    onsubmit() {
      alert("แก้ไขสินค้าเสร็จสิ้น");
      this.$router.push({
        name: "manageItem",
      });
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
